module.exports = __webpack_public_path__ + "static/media/service-ecommerce-desktop.a7e413e0.png";